import ApplicantRepository from "../../ports/applicantRepository";
import { ApplicantDocument } from "../../../entities/applicant";

export type deleteApplicantDocumentsUsecase = (
  id: string,
  document: ApplicantDocument
) => Promise<void>;

export const buildDeleteApplicantDocuments = (dependencies: {
  applicantRepo: ApplicantRepository;
}): deleteApplicantDocumentsUsecase => {
  const { applicantRepo } = dependencies;

  const deleteApplicantDocuments:deleteApplicantDocumentsUsecase = async (
    id: string,
    document: ApplicantDocument
  ) => applicantRepo.deleteApplicantDocuments(id, document);

  return deleteApplicantDocuments;
};
